import BasketItemModelBase from '../_generated/modelBases/basket-item-model-base';

export default class BasketItemModel extends BasketItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
